import z from "zod";

// Helper to normalize to YYYY-MM-DD
function toDateOnlyString(date: Date) {
  return date.toISOString().split("T")[0];
}

export const DateOnlySchema = z.preprocess(
  (arg) => {
    // 1. Preprocess: Allow Dates or Strings to be passed in
    if (typeof arg === "string" || arg instanceof Date) {
      const d = new Date(arg);
      // If valid date, standardize to string immediately
      if (!isNaN(d.getTime())) return toDateOnlyString(d);
    }
    return arg; // Pass through for Zod to catch validity errors
  },
  z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Format must be YYYY-MM-DD")
    .refine((dateStr) => {
      // 2. Refine: Ensure the date actually exists (e.g., reject 2023-02-30)
      const date = new Date(dateStr);
      const [year, month, day] = dateStr.split("-").map(Number);

      // Check if JS Date rollover occurred (UTC assumption)
      return (
        date.getUTCFullYear() === year &&
        date.getUTCMonth() + 1 === month &&
        date.getUTCDate() === day
      );
    }, "Invalid calendar date")
);

export type DateOnly = z.infer<typeof DateOnlySchema>;
